import { theme } from 'antd'
import { ThemeCommon } from './theme.common'
import { ThemeType } from './theme.config'

export const ThemeLight: ThemeType = {
  algorithm: theme.defaultAlgorithm,
  token: {
    ...ThemeCommon.token,
  },
  components: {
    Layout: {
      headerBg: 'white',
      headerPadding: 0,
    },
  },
}
